import { render, staticRenderFns } from "./SliderSection.vue?vue&type=template&id=f139818c&scoped=true&"
import script from "./SliderSection.vue?vue&type=script&lang=js&"
export * from "./SliderSection.vue?vue&type=script&lang=js&"
import style0 from "./SliderSection.vue?vue&type=style&index=0&id=f139818c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f139818c",
  null
  
)

export default component.exports